import styled from "styled-components";

export const Card = styled.div`
    background: #f5f6fa;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    width: 255px;
    font-family: 'Inter', Arial, sans-serif;
    display: flex;
    padding: 4px 24px 4px 24px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
    border-radius: 6px;
    `;
  
export const ImageWrapper = styled.div`
    position: relative;
    width: 230px;
    height: 200px;
    overflow: hidden;
    padding: 10px 10px 0 10px;
    display: flex;
    justify-content: center;
    align-items: start;
    border-radius: 5px;
`;
  
export const Image = styled.img`
    
    width: 230px;
    height: 150px;
    object-fit: cover;
    object-position: center;
    border-radius: 5px;
`;
  
export const Tag = styled.div`
    position: absolute;
    left: 0px;
    bottom: 5px;
    color: #003366;
    font-size: 15px;
    padding: 4px 12px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    font-weight: 600;
`;
  
export const Content = styled.div`
    width: 100%;
`;
  
export const PlayerName = styled.div`
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 6px;
`;
  
export const Meta = styled.div`
    font-size: 12px;
    margin-bottom: 12px;
`;
  
export const Bold = styled.span`
    font-weight: 700;
    color: #022142;
    font-size: 12px;
`;
  
export const Stats = styled.div`
    font-size: 12px;
    color: #444;
    margin-bottom: 14px;
`;
  
export const Cups = styled.div`
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-top: 8px;
`;
  
export const CupIcon = styled.div`
    margin-right: 2px;
`;
  
export const CupsText = styled.div`
    font-size: 12px;
    margin-left: 8px;
    color: #444;
`;